import { replace } from "svelte-spa-router";

export function navigateToLetters() {
  navigate("/letters");
}
export function navigateToNature() {
  navigate("/nature");
}
export function navigateToCulture() {
  navigate("/culture");
}
export function navigateToWorld() {
  navigate("/world");
}
function navigate(target) {
  replace(target);
}
